import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Faq } from '../../shared/types/FaqDto';
import { TranslationService } from '../../shared/translation.service';

@Component({
  selector: 'lp2-faq-container',
  template: `
    <div class="faq-container">
      <h3 class="faqs-title">{{ 'talkNow.topAdvisorQuestions' | translate }}</h3>
      <ul>
        <li *ngFor="let faq of faqs | slice: 0:3; index as i">
          <hr />
          <div class="faq">
            <span class="counter">{{ '0' + (i + 1) }}</span>
            <div class="description">
              <p>{{ faq.question }}</p>
            </div>
          </div>
        </li>
      </ul>

      <a [href]="faqLink" class="more-faqs-btn">{{ 'talkNow.seeAdvisorFAQs' | translate }}</a>
    </div>
  `,
  styleUrls: ['./faq-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqContainerComponent implements OnInit {
  @Input() faqs: Array<Faq>;

  faqLink: string;

  constructor(private translationService: TranslationService) {}

  ngOnInit(): void {
    this.faqLink = this.translationService.translate('oeApp.faq.link');
  }
}



// WEBPACK FOOTER //
// ./ts/app/contact-us/faq-container/faq-container.component.ts